<template>
  <nav class="te-navbar-page relative w-full border-b border-[#ddd] bg-co-gray-50 pb-px">
    <div class="co-container-lg navbar w-full justify-between px-4 py-0">
      <div class="max-w-[calc(100%-10rem)] flex-1">
        <!-- SP表示有り、コース名アイコン無し、末尾に...をつける -->
        <a
          v-if="!$slots.courseicon"
          class="inline-block truncate text-[1rem] text-co-gray-700 hover:text-co-gray-700 sm:text-[1.25rem] md:max-w-full"
          href="#cover"
          @click.prevent="scrollTo('cover')"
        >
          <slot name="coursename">
            コース名が入ります
          </slot>
        </a>
        <!-- コース名アイコン有り -->
        <a
          v-else-if="$slots.courseicon"
          class="flex items-center justify-center truncate text-[1rem] text-co-gray-700 hover:text-co-gray-700 sm:text-[1.25rem] md:max-w-full"
          href="#cover"
          @click.prevent="scrollTo('cover')"
        >
          <slot name="courseicon" />
          <slot name="coursename">
            コース名が入ります
          </slot>
        </a>
        <!-- SPナビゲーション開閉ボタン、横幅63px -->
        <button
          class="flex flex-col items-center break-keep px-5 text-[1rem] lg:hidden"
          @click="isMenuOpen = !isMenuOpen"
        >
          <FontAwesomeIcon :icon="faListUl" />
          <div class="mt-1 text-[0.625rem] font-bold tracking-[.15em] text-co-gray-700">
            目次
          </div>
        </button>
      </div>
      <div class="flex-none">
        <!-- PCメニュー -->
        <ul class="hidden lg:flex">
          <slot name="menu">
            <!-- デフォルトの表示はコースページのナビゲーション -->
            <li>
              <a
                class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
                :href="'#about'"
                @click.prevent="scrollTo('about')"
              >
                概要
              </a>
            </li>
            <li>
              <a
                class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
                :href="'#curriculum'"
                @click.prevent="scrollTo('curriculum')"
              >
                カリキュラム
              </a>
            </li>
            <li>
              <a
                class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
                :href="'#price'"
                @click.prevent="scrollTo('price')"
              >
                料金
              </a>
            </li>
            <li>
              <a
                class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
                :href="'#flow'"
                @click.prevent="scrollTo('flow')"
              >
                受講の流れ
              </a>
            </li>
            <!-- 251202導線削除 -->
            <!-- <li>
              <a
                class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
                :href="'#faq'"
                @click.prevent="scrollTo('faq')"
              >
                FAQ
              </a>
            </li> -->
          </slot>
        </ul>
        <!-- ボタン、横幅164px -->
        <!-- 251202導線削除 -->
        <!-- <div class="flex gap-x-2">
          <a
            class="bot_open co-btn-counseling !px-3 !py-2"
            href="/counseling/htmlcss-schedule"
          >
            無料相談
          </a>
          <a
            class="co-display-12 co-text-white-1 inline rounded-full bg-co-primary-500 px-3 py-2 text-co-gray-50 hover:text-co-gray-50"
            href="#apply"
            @click.prevent="scrollTo('apply')"
          >
            申込む
          </a>
        </div> -->
      </div>
    </div>
    <!-- SP表示開閉メニュー -->
    <Transition name="fade">
      <ul
        v-show="isMenuOpen"
        class="te-collapse flex flex-col lg:hidden"
      >
        <slot name="menu">
          <!-- デフォルトの表示はコースページのナビゲーション -->
          <li>
            <a
              class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
              :href="'#about'"
              @click.prevent="scrollTo('about')"
            >
              概要
            </a>
          </li>
          <li>
            <a
              class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
              :href="'#curriculum'"
              @click.prevent="scrollTo('curriculum')"
            >
              カリキュラム
            </a>
          </li>
          <li>
            <a
              class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
              :href="'#price'"
              @click.prevent="scrollTo('price')"
            >
              料金
            </a>
          </li>
          <li>
            <a
              class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
              :href="'#flow'"
              @click.prevent="scrollTo('flow')"
            >
              受講の流れ
            </a>
          </li>
          <!-- 251202導線削除 -->
          <!-- <li>
            <a
              class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
              :href="'#faq'"
              @click.prevent="scrollTo('faq')"
            >
              FAQ
            </a>
          </li> -->
        </slot>
      </ul>
    </Transition>
  </nav>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import { scrollTo } from '~/composables/useSmoothScroll'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faListUl } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

// ナビゲーション開閉
const isMenuOpen = ref(false);

onMounted(() => {
  const navbarPage = document.querySelector('.te-navbar-page');
  if (navbarPage) {
    const navbarTop = navbarPage.offsetTop;
    const handleScroll = () => {
      if (window.scrollY >= navbarTop) {
        navbarPage.classList.add('te-is-fixed');
      } else {
        navbarPage.classList.remove('te-is-fixed');
      }
    };
    window.addEventListener('scroll', handleScroll);
    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });
  }
});
</script>

<style scoped>
.te-navbar-page,
.navbar {
  height: 70px;
}

/* フェードアニメーション */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 開閉ナビゲーション */
.te-collapse {
  @apply absolute top-[70px] left-0 w-full h-auto border-b border-gray-300 overflow-scroll;
  background-color: rgba(255, 255, 255, 0.97);
}

/* メニューの上部固定 */
.te-is-fixed {
  @apply fixed top-0 left-0 right-0 z-[1040];
}

/* :where(.navbar > *:not(script, style)) {
  display: inline;
} */
</style>
